import React, { useState, useEffect } from "react";
import Input from "../Common/CustomInput";
import Permissions from "../Common/Permissions";
import api from "../../setupMiddleware";
import { ToastContainer, toast, Bounce } from "react-toastify";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { extractPermissionIds } from "../../Utils/getUserUtitls";

const EditRole = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location);
  const loading = useApiLoader();
  const [roleName, setRoleName] = useState("");
  const [permissionData, setPermissionData] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  console.log("selectedPermissions", selectedPermissions);

  // const updateRole = async () => {
  //   api
  //     .put(`/api/user-roles/${id}`, {
  //       name: roleName,
  //       // permission_ids: selectedPermissions,
  //     })
  //     .then((res) => {
  //       if (res && res.status === 200) {
  //         toast.success(res.data?.message, {
  //           position: "top-left",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: false,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "colored",
  //           transition: Bounce,
  //         });
  //         window.location = "/role-management";
  //       }
  //     })
  //     .catch((err) => {
  //       if (err) {
  //         alert(err.response?.data?.errors?.name[0]);
  //       }
  //     });
  // };

  const updateRolePermissions = async () => {
    api
      .post(`/api/roles/${id}/permissions`, {
        permission_ids: selectedPermissions,
      })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          setTimeout(() => navigate("/role-management"), 1000);
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.errors?.name[0]);
        }
      });
  };

  const getAllPermissions = async () => {
    api.get("/api/permissions").then((res) => {
      if (res && res.status === 200) {
        setPermissionData(res.data);
      }
    });
  };

  useEffect(() => {
    getAllPermissions();
  }, []);

  useEffect(() => {
    if (!location.state) {
      window.location = "/role-management";
    } else {
      setRoleName(location.state?.name);
      setSelectedPermissions(
        location.state?.permissions?.length > 0
          ? extractPermissionIds(location.state?.permissions)
          : []
      );
    }
  }, [location]);

  return (
    <>
      {loading && <Loader opacity={90} />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Edit Role
          </span>
        </p>
      </div>
      <div className="flex flex-col gap-6 mt-[30px] px-4">
        <div className="flex flex-col gap-2">
          <p className="text-sm text-[#142b70]/80">Role Name</p>
          <div className="relative">
            <Input
              type="text"
              placeholder="Enter Role"
              value={roleName}
              disable={true}
              // onChange={(e) => setRoleName(e.target.value)}
            />
          </div>
        </div>
        <Permissions
          data={permissionData}
          value={selectedPermissions}
          onChange={setSelectedPermissions}
        />
      </div>
      {/* Footer */}
      <div className="flex justify-end gap-4">
        <button
          onClick={updateRolePermissions}
          disabled={roleName && selectedPermissions ? false : true}
          className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
        >
          Update
        </button>
      </div>
      <ToastContainer />
    </>
  );
};

export default EditRole;
